(function () {

    'use strict';

    angular.module('Services').service('AccountsPayableTableService', AccountsPayableTableService);

    AccountsPayableTableService.$inject = ['AccountingService', 'TableLiteFactory', '$filter'];

    function AccountsPayableTableService(AccountingService, TableLiteFactory, $filter) {
        return function (carriers) {
            const tableData = {
                tableName: 'AccountsPayableTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    colMinWidth: '100px'
                },
                headers: [
                    {
                        width: '120px',
                        label: "Carrier",
                        viewName: "carrierLogo",
                        filterName: "carrierId",
                        filter: {
                            type: "select2",
                            placeholder: "Search",
                            filterBy : 'id',
                            items: carriers,
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Account Number',
                        viewName: 'accountNumber',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            },
                            model: '' //optional
                            //text and inputDropdown uses `model` attribute for ng-model
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Invoice Date',
                        viewName: 'dateOfInvoice',
                        filterName: 'dateOfInvoice',
                        filter: {
                            type: 'datePicker',
                            class: 'filter-date',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                                //sendRequest();
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-right',
                        label: 'Total Invoiced from Carrier',
                        viewName: 'totalInvoice',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-right',
                        label: 'Total Billed',
                        viewName: 'totalBilled',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-right',
                        label: 'Margin Value',
                        viewName: 'marginFixed',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'All Consignments Invoiced',
                        viewName: 'shipmentsAllInvoiced',
                        filter: {
                            type: "select2",
                            placeholder: "Select",
                            filterBy : 'shipmentsAllInvoiced',
                            items: [
                                {
                                    value: null,
                                    name: 'All'
                                },
                                {
                                    value: true,
                                    name: 'Yes'
                                },
                                {
                                    value: false,
                                    name: 'No'
                                }
                            ],
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        class: 'text-capitalize',
                        label: 'Status',
                        viewName: 'status',
                        filterName: 'status',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select One',
                            items: ['Discrepancy', 'Disputed', 'Closed', 'Pending'],
                            onSelect: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.AccountsPayable.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (row) {
                    row.carrierLogo = {
                        imgSrc: row.carrier && row.carrier.logoUrl,
                        type: 'logotype'
                    };
                    row.dateOfInvoice = row.dateOfInvoice ? $filter('bbaDate')(row.dateOfInvoice) : 'N/A';
                    row.accountNumber = row.accountNumber || 'N/A';
                    row.totalInvoice = !isNaN(row.totalInvoice) ? $filter('bbaCurrency')(row.totalInvoice) : 'N/A';
                    row.totalBilled = !isNaN(row.totalBilled) ? $filter('bbaCurrency')(row.totalBilled) : 'N/A';
                    row.marginFixed = !isNaN(row.marginFixed) ? $filter('bbaCurrency')(row.marginFixed) : 'N/A';
                    row.shipmentsAllInvoiced = row.shipmentsAllInvoiced ? 'Yes' : 'No';
                    row.href = '/accounting/accounts-payable/' + row.id;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountsPayableTableService.js